import { observable } from "mobx";
import provinces from "./data/provinces.json";

class ProvincesStore {
  @observable provincesList = [];

  constructor() {
    this.provincesList = provinces;
  }

}

export default new ProvincesStore();



// WEBPACK FOOTER //
// ./src/stores/provincesStore/index.js